import { Entity } from "@hds/entity-lib";

class EventRawActivityEntity extends Entity {
    static DEFAULT_DOCUMENT = {
        rawEntries: []
    };
    constructor(entityPersistence, seedData = {}, options = {}) {
        super(entityPersistence, seedData, options);
        this._virtualDataModel.fromJSON({
            ...EventRawActivityEntity.DEFAULT_DOCUMENT,
            ...seedData
        });
    }
    /*****************************************************/
    // START ENTITY DATA MODEL
    /*****************************************************/
    get rawEntries() {
        return this._virtualDataModel.getProperty('rawEntries');
    }
    appendEntry(newEventRawActivity) {
        if (!this._virtualDataModel.hasProperty('rawEntries')) {
            this._virtualDataModel.setProperty('rawEntries', []);
        }
        this.rawEntries.push(newEventRawActivity);
    }
    /*****************************************************/
    // END ENTITY DATA MODEL
    // START OVERRIDDEN METHODS
    /*****************************************************/
    clone() { throw new Error('METHOD_NOT_ALLOWED'); }
    /*****************************************************/
    // END OVERRIDDEN METHODS
    /*****************************************************/
}

//META PROPERTIES
Object.defineProperty(EventRawActivityEntity.prototype, '_meta', {
    value: {
        storeName: 'event-runtime',
        entityName: 'event-raw-activity'
    }
}, { enumerable: false, configurable: false, writable: false, value: "static" });

export { EventRawActivityEntity };
export default EventRawActivityEntity;